import { Footer } from "../components/Footer"
import { PayoutCoinflowMethods } from "../components/payout/PayoutCoinflowMethods"


export const PayoutCoinflowPage = () => {
    return (
        <div className="container">
            <PayoutCoinflowMethods />
            <Footer />
        </div>
    );
}